/**
 * ImportPreviewVariableChip — chip copiável para tokens de variável.
 *
 * RELEASE:
 *   2026-05-17 v1.0.0 - Extraído de ListPreviewDialog.
 */
import { Copy } from 'lucide-react';
import { cn } from '@/lib/utils';

interface ImportPreviewVariableChipProps {
  token: string;
  variant: 'primary' | 'outline';
  onCopy: (token: string) => void;
}

export function ImportPreviewVariableChip({
  token,
  variant,
  onCopy,
}: ImportPreviewVariableChipProps) {
  return (
    <button
      type="button"
      onClick={() => onCopy(token)}
      className={cn(
        'group inline-flex items-center gap-1.5 h-6 px-2 rounded-md text-[11px] font-mono',
        'border transition-colors',
        variant === 'primary'
          ? 'bg-primary/10 text-primary border-primary/20 hover:bg-primary/15'
          : 'bg-background text-foreground border-border hover:bg-muted',
      )}
      title="Clique para copiar"
    >
      <span>{token}</span>
      <Copy className="h-2.5 w-2.5 opacity-50 group-hover:opacity-100 transition-opacity" />
    </button>
  );
}
